import React from "react";
import { Box, Typography } from "@mui/material";
import OverdueInvoicesCard from "./Billing/OverdueInvoicesCard";
import EducationDashboardCards from "./EducationDashboardCards";
import { useOrganizationLabels } from "../../hooks/useOrganizationLabels";

const EducationHomePage: React.FC = () => {
  const org = useOrganizationLabels();

  return (
    <Box data-testid="education-home-page" sx={{ p: 3, maxWidth: 720 }}>
      <Typography variant="h5" component="h1" gutterBottom>
        {org.dashboardHomeTitle}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        {org.dashboardHomeBody}
      </Typography>
      <EducationDashboardCards />
      <OverdueInvoicesCard />
    </Box>
  );
};

export default EducationHomePage;
